export default __webpack_public_path__ + "static/media/ellips-2.55809f1e.svg";